module.exports = __webpack_public_path__ + "static/img/balloons.ad6bdfb.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/accessories/thumbnail/balloons.png
// module id = jpJA
// module chunks = 0